import isEmpty from 'lodash/isEmpty';
import * as Yup from 'yup';
import { targetValidationNullable } from '../../../../const/targetValidationNullable';
import { errorMessages } from '../../../../const/dateValidator';



export const mkValidationSchema = (
  featureConfig,
  unavailableDates = [],
  dynamicData = {},
  currentReleasedAt = null,
  currentReleasedTo = null,
  allowUpdateInThePast = false,
  typeOptions = [],
) => Yup.lazy((values) => Yup.object().shape({
  title: Yup.string().nullable()
    .min(3, 'Min 3 symbols required')
    .max(2000, 'Max 2000 symbols required'),
  description: Yup.string().nullable()
    .min(1, 'Min 1 symbol required')
    .max(1000, 'Max 1000 symbols required'),
  template_id: Yup.number().required('Required to specify template ID'),
  ...!isEmpty(typeOptions) && {
    type: Yup.string().required('Required to choose type'),
  },
  released_at: Yup.date().default(currentReleasedAt ? new Date(currentReleasedAt) : null)
    .when('is_published', {
      is: false,
      then: (schema) => schema.nullable(),
      otherwise: (schema) => schema.required(errorMessages.releasedAt.required),
    })
    .afterYesterday(errorMessages.releasedAt.afterYesterday, { allowUpdateInThePast })
    .before(values?.released_to, errorMessages.releasedAt.before)
    .makeUnavailable(unavailableDates),
  ...featureConfig?.config?.release_range && {
    released_to: Yup.date().default(currentReleasedTo ? new Date(currentReleasedTo) : null)
      .when('is_published', {
        is: false,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required(errorMessages.releasedTo.required),
      })
      .afterYesterday(errorMessages.releasedTo.afterYesterday, { allowUpdateInThePast })
      .after(values?.released_at, errorMessages.releasedTo.after),
  },
  ...dynamicData,
  target: Yup.object().shape(targetValidationNullable(values)),
}));


export const DEFAULT_RELEASE_TIME = '04:00:00';
export const NO_LINES_HASHTAG_VALUE = 'nolines';
export const MYSTERY_CATEGORY_VALUE = 'Mystery';
